import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer p-3">
      <h5>Fake Shop</h5>
      <p>&copy; Mostafa Rakib, All rights reserved, 2022</p>
    </div>
  );
};

export default Footer;
